var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm4.75 10.42-7 4A.5.5 0 0 1 9 16V8a.49.49 0 0 1 .74-.43l7 4a.51.51 0 0 1 .01.85Z"
})));
export default SvgPlay;